import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";

import SelectMultiple from '../SelectMultiple/SelectMultiple';
import Select from '../Select/Select'

import { updateCustomerInfo } from '../../store/customer/actions';

import { colors } from "../../styles/variables.js"
import Svg from "../../../src/assets/icons/icons.js"

import { UlSt } from '../Select/style.js';
import {
  AreaSt,
  EditSt,
  ContainerAreaSt,
  WrapHeaderSt,
  WrapContentSt,
  VerifedSt,
  VerifedTextSt,
  WrapTooltip,
  ButtonSaveSt,
  WrapSelectSt,
  WrapTopSt,
  WrapLogoSt,
  LineSt,
  LineLeftSt,
  LineRightSt,
  TooltipWrapSt,
  SpanSt
} from './style.js'

import i18n from "i18next";

const emptyFormErrors = {
  password: '', email: '', fullName: '', newEmail: '', confirmPassword: '',
  country: '', newPassword: '', company: '', position: '', genresChosen: '',
  rightChosen: '', territoryChosen: '',
};

const sortingData = (data) => {
  if (data === undefined) {
    return []
  } else
    return data.filter(item => item.checked === true)
      .map(item => item.id)
};

const AccountProfile = ({
  verifed, country, territory, genres, typeOfRights, logoCompany,
  mail, company, managerName, position, fullPosition,
}) => {
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  // редактируемые поля
  const [fields, setFields] = useState({
    full_name: managerName,
    email: mail,
    company_name: company,
    position: position,
    password: "",
  });

  // какое поле сейчас в режиме редактирования
  const [active, setActive] = useState({
    full_name: false,
    email: false,
    company_name: false,
    position: false,
    password: false,
  });

  /*ошибки*/
  const [errorsFullName, setErrorsFullName] = useState(false);
  const [errorsMail, setErrorsMail] = useState(false);
  const [errorsCompany, setErrorsCompany] = useState(false);
  const [errorsPassword, setErrorsPassword] = useState(true);
  const [formErrors] = useState(emptyFormErrors);

  const dispatch = useDispatch();
  const customer = useSelector((store) => store.customer);
  const token = useSelector((store) => store.auth.dataToken.token);

  const _validFullName = (value) => {
    setErrorsFullName(value.length > 35 || value.length === 0 || value.length <= 3);
  };

  const _validCompany = (value) => {
    setErrorsCompany(value.length > 35 || value.length === 0);
  };

  const _validPassword = (value) => {
    setErrorsPassword(value.length > 35 || value.length === 0 || value.length < 8);
  };

  const _validEmail = (value) => {
    const pattern = /^([a-z0-9_.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
    setErrorsMail(!pattern.test(value));
  };

  const _handleChange = (evt) => {
    const { name, value } = evt.target;
    setFields((prev) => ({ ...prev, [name]: value }));

    if (name === "full_name") {
      _validFullName(value)
    }
    if (name === "company_name" || name === "position") {
      _validCompany(value)
    }
    if (name === "password") {
      _validPassword(value)
    }
    if (name === "email") {
      _validEmail(value)
    }
  };

  const _handleFocus = (name) => {
    setActive((prev) => ({ ...prev, [name]: "active" }));
  };

  const _handleNotFocus = (name, type) => {
    setActive((prev) => ({ ...prev, [name]: false }));
    if (type !== "not") {
      dispatch(updateCustomerInfo({ [name]: fields[name] }, token));
    }
  };

  const _handleTooltipEnter = () => {
    setTooltipIsOpen(true);
  };

  const _handleTooltipLeave = () => {
    setTooltipIsOpen(false);
  };

  const _showSearchingResults = (x) => {
    dispatch(updateCustomerInfo({ country_id: x }, token));
  };

  const _updateSelectData = useCallback((data, selectName) => {
    const dataSort = sortingData(data);
    dispatch(updateCustomerInfo({ [selectName]: dataSort }, token));
  }, [dispatch, token]);

  return (
    <form>
      <WrapTopSt>
        <WrapHeaderSt>
          {verifed === "PRO"
            ? <VerifedSt >
              <WrapTooltip onMouseEnter={_handleTooltipEnter} onMouseLeave={_handleTooltipLeave} >
                <Svg width="24" height="24" type="verified"></Svg>
                <VerifedTextSt className="line">Pro</VerifedTextSt>
                {(tooltipIsOpen)
                  ? <TooltipWrapSt>
                    <UlSt>
                      <SpanSt>{i18n.t(`profile.concluding`)}</SpanSt>
                    </UlSt>
                  </TooltipWrapSt>
                  : null}
              </WrapTooltip>
            </VerifedSt>
            : <VerifedSt>
              <WrapTooltip>
                <Svg width="24" height="24" type="work_outline"></Svg>
                <VerifedTextSt>PARTNER</VerifedTextSt>
              </WrapTooltip>
            </VerifedSt>
          }

          <EditSt className={active.full_name === "active" && "active focus"}>
            <ContainerAreaSt className={active.full_name === "active" ? "header focus" : "header"}>
              {!active.full_name && <span>{managerName}</span>} {/*нужно для ширины и высоты в зависисмости от количества текста*/}
              {active.full_name && <AreaSt
                className="header"
                value={fields.full_name}
                name="full_name"
                autoFocus={active.full_name === "active" ? true : false}
                onChange={(e) => _handleChange(e)}
                readOnly={active.full_name === "active" ? false : true}
                maxLength="36"
              />}
            </ContainerAreaSt>
            {active.full_name === "active"
              ? <>
                <ButtonSaveSt onClick={() => _handleNotFocus('full_name')} type="submit" disabled={errorsFullName ? "disabled" : false} >
                  <Svg type="check" color={!errorsFullName ? `${colors.aqua_light}` : `${colors.grey_passive}`} width="24" height="24" />
                </ButtonSaveSt>
                <ButtonSaveSt onClick={() => _handleNotFocus('full_name', 'not')} type="submit">
                  <Svg type="close" color={colors.black_text} width="24" height="24" />
                </ButtonSaveSt>
              </>
              : <span onClick={() => _handleFocus('full_name')}>
                <Svg type="edit" color={colors.grey_passive} width="24" height="24" />
              </span>
            }
          </EditSt>

        </WrapHeaderSt>

        <WrapLogoSt>
          <img src={logoCompany} alt="" />
        </WrapLogoSt>

      </WrapTopSt>

      <EditSt>
        <ContainerAreaSt className="header-small visible">
          {fullPosition} {/*нужно для ширины и высоты в зависисмости от количества текста*/}
        </ContainerAreaSt>
      </EditSt>

      <WrapContentSt>

        {/*поле для отображения/замены email*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>E-mail</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <EditSt className={active.email === "active" ? "focus" : ""}>
              <ContainerAreaSt className={active.email === "active" ? "focus" : ""}>
                {!active.email && <span>{mail}</span>} {/*нужно для ширины и высоты в зависисмости от количества текста*/}
                {active.email && <AreaSt
                  value={fields.email}
                  name="email"
                  autoFocus={active.email === "active" ? true : false}
                  onChange={(e) => _handleChange(e)}
                  readOnly={active.email === "active" ? false : true}
                />}
              </ContainerAreaSt>
              {active.email === "active"
                ? <>
                  <ButtonSaveSt onClick={() => _handleNotFocus('email')} type="submit" disabled={errorsMail ? "disabled" : false}>
                    <Svg type="check" color={!errorsMail ? `${colors.aqua_light}` : `${colors.grey_passive}`} width="24" height="24" />
                  </ButtonSaveSt>
                  <ButtonSaveSt onClick={() => _handleNotFocus('email', 'not')} type="submit">
                    <Svg type="close" color={colors.black_text} width="24" height="24" />
                  </ButtonSaveSt>
                </>
                : <span onClick={() => _handleFocus('email')}>
                  <Svg type="edit" color={colors.grey_passive} width="24" height="24" />
                </span>
              }
            </EditSt>
          </LineRightSt>
        </LineSt>

        {/*поле для отображения/замены названия компании*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>{i18n.t(`profile.company`)}</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <EditSt className={active.company_name === "active" ? "focus" : ""}>
              <ContainerAreaSt className={active.company_name === "active" ? "focus" : ""}>
                {!active.company_name && <span>{company}</span>} {/*нужно для ширины и высоты в зависисмости от количества текста*/}
                {active.company_name === "active" &&
                  <AreaSt
                    value={fields.company_name}
                    name="company_name"
                    autoFocus={active.company_name === "active" ? true : false}
                    onChange={(e) => _handleChange(e)}
                    readOnly={active.company_name === "active" ? false : true}
                  />
                }
              </ContainerAreaSt>
              {active.company_name === "active"
                ? <>
                  <ButtonSaveSt onClick={() => _handleNotFocus('company_name')} type="submit" disabled={errorsCompany ? "disabled" : false} >
                    <Svg type="check" color={!errorsCompany ? `${colors.aqua_light}` : `${colors.grey_passive}`} width="24" height="24" />
                  </ButtonSaveSt>
                  <ButtonSaveSt onClick={() => _handleNotFocus('company_name', 'not')} type="submit">
                    <Svg type="close" color={colors.black_text} width="24" height="24" />
                  </ButtonSaveSt>
                </>
                : <span onClick={() => _handleFocus('company_name')}>
                  <Svg type="edit" color={colors.grey_passive} width="24" height="24" />
                </span>
              }
            </EditSt>
          </LineRightSt>
        </LineSt>

        {/*поле для отображения/замены должности*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>{i18n.t(`profile.position`)}</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <EditSt className={active.position === "active" ? "focus" : ""}>
              <ContainerAreaSt className={active.position === "active" ? "focus" : ""}>
                {!active.position && <span>{position}</span>}{/*нужно для ширины и высоты в зависисмости от количества текста*/}
                {active.position === "active" &&
                  <AreaSt
                    value={fields.position}
                    name="position"
                    autoFocus={active.position === "active" ? true : false}
                    onChange={(e) => _handleChange(e)}
                    readOnly={active.position === "active" ? false : true}
                  />
                }
              </ContainerAreaSt>
              {active.position === "active"
                ? <>
                  <ButtonSaveSt onClick={() => _handleNotFocus('position')} type="submit" disabled={errorsCompany ? "disabled" : false} >
                    <Svg type="check" color={!errorsCompany ? `${colors.aqua_light}` : `${colors.grey_passive}`} width="24" height="24" />
                  </ButtonSaveSt>
                  <ButtonSaveSt onClick={() => _handleNotFocus('position', 'not')} type="submit">
                    <Svg type="close" color={colors.black_text} width="24" height="24" />
                  </ButtonSaveSt>
                </>
                : <span onClick={() => _handleFocus('position')}>
                  <Svg type="edit" color={colors.grey_passive} width="24" height="24" />
                </span>
              }
            </EditSt>
          </LineRightSt>
        </LineSt>

        {/*поле для отображения/замены страны*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>{i18n.t(`profile.country`)}</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <WrapSelectSt>
              <Select
                primary
                content={country}
                className={formErrors.country !== '' ? "invalid" : ""}
                error={formErrors.country}
                name="country"
                selectWidth="true"
                _showSearchingResults={(x) => _showSearchingResults(x)}
              />
            </WrapSelectSt>
          </LineRightSt>
        </LineSt>

        {/*поле для отображения/замены пароля*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>{i18n.t(`profile.pass`)}</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <EditSt className={active.password === "active" ? "password focus" : "password"} disabled={errorsPassword ? "disabled" : false} >
              <ContainerAreaSt className={active.password === "active" ? "focus" : ""}>
                {!active.password && <span className="password">&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;</span>}
                {active.password &&
                  <AreaSt
                    value={fields.password}
                    name="password"
                    autoFocus={active.password === "active" ? true : false}
                    onChange={(e) => _handleChange(e)}
                    readOnly={active.password === "active" ? false : true}
                    placeholder="введите новый пароль"
                  />
                }
              </ContainerAreaSt>
              {active.password === "active"
                ? <>
                  <ButtonSaveSt onClick={() => _handleNotFocus('password')} type="submit">
                    <Svg type="check" color={!errorsPassword ? `${colors.aqua_light}` : `${colors.grey_passive}`} width="24" height="24" />
                  </ButtonSaveSt>
                  <ButtonSaveSt onClick={() => _handleNotFocus('password', 'not')} type="submit">
                    <Svg type="close" color={colors.black_text} width="24" height="24" />
                  </ButtonSaveSt>
                </>
                : <span onClick={() => _handleFocus('password')}>
                  <Svg type="edit" color={colors.grey_passive} width="24" height="24" />
                </span>
              }
            </EditSt>
          </LineRightSt>
        </LineSt>

        {/*поле для отображения/замены территории интересующих прав*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>{i18n.t(`profile.territory`)}</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <WrapSelectSt>
              <SelectMultiple
                primary
                name="countries"
                content={territory}
                action="edit"
                updateData={_updateSelectData}
              />
            </WrapSelectSt>
          </LineRightSt>
        </LineSt>

        {/*поле для отображения/замены вида прав*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>{i18n.t(`profile.type_of_rights`)}</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <WrapSelectSt>
              <SelectMultiple
                primary
                name="rights"
                content={typeOfRights}
                action="edit"
                updateData={_updateSelectData}
              />
            </WrapSelectSt>
          </LineRightSt>
        </LineSt>

        {/*поле для отображения/замены интересующих прав*/}
        <LineSt className="profile">
          <LineLeftSt className="profile">
            <span>{i18n.t(`profile.genres_of_interest`)}</span>
          </LineLeftSt>
          <LineRightSt className="profile">
            <WrapSelectSt>
              <SelectMultiple
                primary
                content={genres}
                name="genres"
                position="top"
                action="edit"
                viewType="popup"
                updateData={_updateSelectData}
              />
            </WrapSelectSt>
          </LineRightSt>
        </LineSt>

      </WrapContentSt>
      {(Object.keys(customer.errors).length !== 0) && (
        Object.values(customer.errors).map((error, index) => {
          return (
            <div key={index}>{error}</div>
          )
        })
      )}

    </form>
  );
};

export default AccountProfile;
